export default {
  section: 'Market Map',
  config: {
    standalone: true,
    title: 'Value Chain Category',
  },
};
